class FetchApi {
    static headers = {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
        // 'Content-Type': 'application/x-www-form-urlencoded',
    };

    static httpFetch({
        url,
        method = "GET",
        mode = "cors",
        cache = "default",
        redirect = "follow",
        referrerPolicy = "no-referrer",
        credentials = "include",
        data = null,
        headers = FetchApi.headers
    }) {
        return new Promise((resolve, reject) => {
            let res = null;
            fetch(url, {
                method,
                mode,
                cache,
                credentials,
                redirect,
                referrerPolicy,
                headers,
                body: data ? JSON.stringify(FetchApi.trimStringsInObject(data)) : null
            })
                .then((response) => {
                    res = response;
                    if (res.ok && res.status == 200) {
                        return res.json();
                    } else {
                        reject(res);
                    }
                })
                .then((formatted) => {
                    if (formatted && formatted.success == 0) {
                        reject(formatted);
                    }

                    resolve(formatted);
                });
        });
    }

    static trimStringsInObject(obj) {
        if (typeof obj !== "object" || obj === null) {
            // Return the input if it's not an object or null
            return obj;
        }

        // Process each property in the object
        for (const prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                if (typeof obj[prop] === "string") {
                    // Trim the string value
                    obj[prop] = obj[prop].trim();
                } else if (typeof obj[prop] === "object") {
                    // Recursively trim strings in nested objects
                    obj[prop] = FetchApi.trimStringsInObject(obj[prop]);
                }
            }
        }

        return obj;
    }
}

export default FetchApi.httpFetch;
